export type NavIcon =
  | 'mapPin'
  | 'target'
  | 'penLine'
  | 'share'
  | 'mail'
  | 'phone'
  | 'bot'
  | 'messages'
  | 'star'
  | 'monitor'
  | 'zap'
  | 'layout'

export type NavSubItem = {
  name: string
  description: string
  href: string
  icon: NavIcon
}

export type NavItem = {
  name: string
  href: string
  route?: 'pricing' | 'contact' | 'industries' | 'crm'
  children?: NavSubItem[]
}

export const marketingServices: NavSubItem[] = [
  { name: 'Local SEO', description: 'Rank on Google Maps & local search', href: '#/marketing/local-seo', icon: 'mapPin' },
  { name: 'Lead Generation — PPC', description: 'Google & Meta ads that convert', href: '#/marketing/ppc', icon: 'target' },
  { name: 'Content Creation', description: 'Blogs, video & copy that sells', href: '#/marketing/content', icon: 'penLine' },
  { name: 'Social Media Marketing', description: 'Consistent posts & engagement', href: '#/marketing/social', icon: 'share' },
  { name: 'Email Marketing', description: 'Nurture sequences & broadcasts', href: '#/marketing/email', icon: 'mail' },
  { name: 'Advanced Phone System', description: 'Calls, texting & call tracking', href: '#/marketing/phone-system', icon: 'phone' },
  { name: 'AI Phone Attendant', description: 'Answers every call, 24/7', href: '#/marketing/ai-phone', icon: 'bot' },
  { name: 'AI Support', description: 'Chat & automatic lead follow-up', href: '#/marketing/ai-support', icon: 'messages' },
  { name: 'Reputation Management', description: 'More 5-star reviews, on autopilot', href: '#/marketing/reputation', icon: 'star' },
]

export const designServices: NavSubItem[] = [
  { name: 'Website Design', description: 'Websites that update in minutes', href: '#/design/websites', icon: 'monitor' },
  { name: '3-Day Website Launch', description: 'Designed, built & live in 72 hours', href: 'https://3daywebsite.adroimarketing.com/', icon: 'zap' },
  { name: 'Landing Pages', description: 'Campaign pages for your ads', href: '#/design/landing-pages', icon: 'layout' },
]

export const navItems: NavItem[] = [
  { name: 'Marketing', href: '#/marketing', children: marketingServices },
  { name: 'Web Design', href: '#/design', children: designServices },
  { name: 'CRM', href: '#/crm', route: 'crm' },
  { name: 'Pricing', href: '#/pricing', route: 'pricing' },
  { name: 'Industries', href: '#/industries', route: 'industries' },
  { name: 'Company', href: '#/company' },
]
